var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48863 14.8259H20.4886C22.1553 13.6593 24.4886 10.7259 20.4886 8.32592C19.6553 4.49259 15.8886 -2.37408 7.48863 0.825919C6.82197 1.326 5.48863 2.82617 5.48863 4.82617C2.48863 5.826 -2.51137 9.22572 1.48863 14.8259ZM9.48828 3.32617H13.4883V9.32617H15.4883L11.4883 12.3262L7.48863 9.32617H9.48828V3.32617Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4bcf899fee59ff2e9d0350d9ee2558b4.svg";
export { ForwardRef as ReactComponent };